export default function FeatureSection() {
  const features = [
    {
      icon: 'ri-search-line',
      title: 'Ricerca piu veloce',
      desc: 'Trova prodotti organizzati senza perdere ore nella ricerca manuale.',
      image: 'https://readdy.ai/api/search-image?query=Woman%20quickly%20scanning%20organized%20product%20grid%20on%20tablet%20device%20in%20bright%20modern%20room%20warm%20natural%20daylight%20neutral%20cream%20walls%20minimalist%20lifestyle%20editorial%20photography%20european%20style%20efficient%20shopping%20focused%20expression%20soft%20shadows&width=600&height=400&seq=feat-speed-2026&orientation=landscape',
    },
    {
      icon: 'ri-scales-line',
      title: 'Migliore confronto',
      desc: 'Analizza diverse opzioni prima dell\'acquisto con dati chiari e organizzati.',
      image: 'https://readdy.ai/api/search-image?query=Side%20by%20side%20product%20comparison%20on%20laptop%20screen%20with%20detailed%20specifications%20visible%20light%20cream%20desk%20soft%20natural%20daylight%20minimalist%20editorial%20photography%20warm%20neutral%20tones%20european%20style%20analytical%20shopping%20decision%20making%20concept&width=600&height=400&seq=feat-compare-2026&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Maggiore controllo',
      desc: 'Valuta qualita, immagini e informazioni prima di prendere una decisione.',
      image: 'https://readdy.ai/api/search-image?query=Person%20carefully%20examining%20product%20details%20on%20laptop%20with%20magnifying%20glass%20nearby%20on%20light%20cream%20desk%20soft%20natural%20daylight%20minimalist%20editorial%20photography%20warm%20neutral%20tones%20european%20style%20quality%20control%20thorough%20review%20concept&width=600&height=400&seq=feat-control-2026&orientation=landscape',
    },
    {
      icon: 'ri-emotion-happy-line',
      title: 'Metodo piu semplice',
      desc: 'Adatto anche ai principianti, con guide passo passo in italiano.',
      image: 'https://readdy.ai/api/search-image?query=Beginner%20friendly%20setup%20with%20simple%20laptop%20showing%20tutorial%20guide%20on%20screen%20light%20cream%20desk%20soft%20natural%20daylight%20minimalist%20editorial%20photography%20warm%20neutral%20tones%20european%20style%20easy%20learning%20welcoming%20workspace%20concept&width=600&height=400&seq=feat-simple-2026&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-accent-50/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-4">
            Perche Sceglierlo
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Perche sempre piu utenti utilizzano Itaobuy Spreadsheet?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, idx) => (
            <div key={idx} className="bg-white rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer">
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={feat.image}
                  alt={feat.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`${feat.icon} text-accent-600 text-lg`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-center gap-10">
            <div className="flex-1">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-4">
                Cos&apos;e
              </span>
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
                Cos&apos;e Itaobuy Spreadsheet?
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                Itaobuy Spreadsheet e uno strumento organizzato che permette agli utenti di trovare, confrontare e analizzare prodotti in modo piu semplice.
              </p>
              <p className="text-foreground-600 text-sm leading-relaxed">
                Invece di cercare manualmente migliaia di articoli, una spreadsheet permette di avere informazioni ordinate come categorie, immagini, prezzi e dettagli prodotto.
              </p>
            </div>
            <div className="flex-1 w-full">
              <div className="rounded-xl overflow-hidden aspect-video">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20bright%20workspace%20with%20laptop%20showing%20organized%20product%20catalog%20grid%20on%20screen%20warm%20oak%20desk%20with%20coffee%20cup%20and%20small%20plant%20soft%20natural%20daylight%20streaming%20from%20window%20minimalist%20editorial%20photography%20european%20style%20productive%20calm%20atmosphere%20clean%20composition&width=800&height=450&seq=feat-about-2026&orientation=landscape"
                  alt="Itaobuy Spreadsheet strumento organizzazione prodotti"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}